import React, { AriaAttributes, DOMAttributes } from 'react'
import { Button } from '@mobi/component-library/Base/Buttons'

interface ButtonProps<T> extends AriaAttributes, DOMAttributes<T> {
  isFullWidth?: boolean
}

// encapsulating the Button component (vs a styled component) because emotion doesn't support downstream
// assignment of user defined parameters (e.g. 'size')
export const VenueModeButton: React.FC<ButtonProps<HTMLButtonElement>> = ({
  isFullWidth = true,
  onClick,
  children,
}) => (
  <Button type='button' size='sm' isFullWidth={isFullWidth} onClick={onClick}>
    {children}
  </Button>
)
